import React from 'react';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from "primereact/dialog";
import { Button } from 'reactstrap';
import "../doctors/FileUpload.css"

export const DialogImgMicrosite = ({
    modalMicrosite,
    closeDialog,
    validateAndUpload, MAX_SIZE
}) => {

     const emptyTemplate = () => (
        <div className="custom-empty">
            <div className="upload-icon text-center">
                <i className="pi pi-cloud-upload"></i>
            </div>
            <div className="upload-text text-center">
                <strong>Arrastra tu imagen aquí</strong>
                <div>o selecciona un archivo desde tu equipo</div>
            </div>
        </div>
    );

    const footer = (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
                color="danger"
                size="sm"
                className="finalizar-btn"
                onClick={closeDialog}
                // style={{ height: "31px", width: "85px" }}
            >
                Cancelar
            </Button>
        </div>
    );
    
  
    
    return (
        <Dialog
            visible={modalMicrosite}
            header="Imagen para login de micrositio"
            onHide={closeDialog}
            modal
            className="medium-dialog"
            footer={footer}
        >
            
<div className="recommend-box">
                <div className="recommend-title">
                    <i className="pi pi-info-circle"></i>
                    RECOMENDACIONES
                </div>

                <div className="recommend-grid">
                    <div>• Proporción: Vertical 4:5</div>
                    <div>• Peso máx: 2MB</div>
                    <div>• Formatos: JPG y PNG</div>
                    <div>• Evita imágenes horizontales</div>
                </div>
            </div>
            
            <div className="upload-zone-modern">
                <FileUpload

                    name="doctor_microsite"
                    customUpload
                    mode="advanced"
                    uploadHandler={validateAndUpload}
                    accept="image/*"
                    maxFileSize={MAX_SIZE}
                    headerTemplate={(options) => {
                        const { chooseButton, uploadButton } = options;

                        return (
                            <div className="custom-header">
                                <div className="left-buttons">
                                    {chooseButton}
                                    {uploadButton}
                                </div>

                               
                            </div>
                        );
                    }}
                    itemTemplate={(file, props) => (
                        <div className="custom-file-card">
                            <img
                                src={file.objectURL}
                                alt={file.name}
                                className="file-preview"
                            />

                            <div className="file-info">
                                <div className="file-name">{file.name}</div>
                                <div className="file-status">Listo para procesar</div>
                            </div>

                            <button
                                className="delete-btn"
                                onClick={() => props.onRemove(file)}
                            >
                                <i className="pi pi-trash"></i>
                            </button>
                        </div>
                    )}
                    emptyTemplate={emptyTemplate}
                    chooseLabel="Seleccionar"
                    uploadLabel="Subir"
                    className="modern-upload"
                />
            </div>


        </Dialog>
    );
};

